// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__WrnTm","content":"styles_content__3RJdU","checkbox":"styles_checkbox__2N_ko","checkboxLabel":"styles_checkboxLabel__1qXUK"};